import env from '../config/env';

/**
 * Where the app sends people outside itself. Opened through the native
 * bridge's openExternal, so a wrapper opens them in the system browser.
 */
/**
 * A page of the dashboard, by its route there: `/settings?tab=trucks`. The
 * dashboard routes in the hash, so the path goes after `#`.
 */
const dashboardPage = (path: string) => `${env.dashboardUrl}/#${path}`;

export const links = {
  dashboard: env.dashboardUrl,
  dashboardPage,
  /** The dashboard's billing tab: the app has no billing of its own. */
  billing: dashboardPage('/settings?tab=billing'),
  // The terms of service and the privacy policy are one page on the site;
  // relaytow.com/terms is not found. The sign-in and sign-up forms link here.
  legal: 'https://relaytow.com/privacy-policy',
  /** The help centre's guides, as the dashboard's welcome note links them. */
  helpCenter: 'https://support.relaytow.com',
  support: 'mailto:support@relaytow.com',
  appStore: env.appStore,
};
